import React from "react";
import {article} from "../../advice/styles";
import {MainLayout} from "../../main-layout";

export const ServiceProverkaTehniki = () => {
    return (
        <MainLayout>
            <div className={article}>
                <div className="container service-page">
                    <section>
                        <div className="row">
                            <div className="header">
                                <h1>
                                    Проверка техники в Лемана ПРО Москва
                                </h1>
                            </div>
                        </div>
                        <div className="row">
                            {/*<div className="slide-menu">*/}
                            {/*    <nav className="navbar nav-bar-fixed" style={{ width: '281px'}}>*/}
                            {/*        <div className="container service-nav white-bg">*/}
                            {/*            <ul className="nav nav-pills nav-stacked">*/}
                            {/*                <li className="nav-item active"><a href="#service_section">Общая*/}
                            {/*                    информация</a></li>*/}
                            {/*            </ul>*/}
                            {/*        </div>*/}
                            {/*    </nav>*/}
                            {/*</div>*/}
                            <div className="service-content">
                                <div className="service-section section">


                                    <div className="service-section-comp" id="service_section"
                                         data-navtitle="Общая информация">

                                        <div className="par service-section-parsys parsys">
                                            <div className="adaptiveImage parbase section">


                                                <img
                                                    src="https://cdn.lemanapro.ru/lmru/image/upload/v1530723543/fudzi/elbrus/images/servicebigicon/desctop/proverka-teh.svg/proverka-teh.svg"
                                                    data-desktopref="https://cdn.lemanapro.ru/lmru/image/upload/v1530723543/fudzi/elbrus/images/servicebigicon/desctop/proverka-teh.svg/proverka-teh.svg"
                                                    data-tabletref="https://cdn.lemanapro.ru/lmru/image/upload/v1530723544/fudzi/elbrus/images/servicebigicon/tablet/check tech tab.svg/check tech tab.svg"
                                                    data-mobileref="https://cdn.lemanapro.ru/lmru/image/upload/v1530723543/fudzi/elbrus/images/servicebigicon/mobile/check tech mob.svg/check tech mob.svg"
                                                    className="resize-image"/>


                                            </div>
                                            <div className="store-selector section">


                                                <div className="store-selector-all-stores">
                                                    <span className="lm icon-circle-info store-selector-info"></span>
                                                    <span className="store-selector-text">Условия предоставления услуги одинаковы во всех магазинах текущего региона</span>
                                                </div>


                                            </div>
                                            <div className="text parbase section"><p><span className="rte-standard">Хотите удостовериться, что приобретаемый товар исправно работает?</span>
                                            </p>
                                                <p><span className="rte-standard"><br/>
Проверьте бытовую технику и электроинструменты самостоятельно! Во всех магазинах Лемана ПРО есть специальные «Столы самостоятельной проверки и упаковки товара», расположенные&nbsp;
                                                    <b>за линией касс</b>. Перед проверкой приобретённого товара внимательно изучите инструкцию и условия гарантийного обслуживания.&nbsp;</span>
                                                </p>
                                                <p><span className="rte-standard"><br/>
Для оформления гарантийного талона обратитесь к специалисту «Информационного бюро» (в&nbsp;<a></a><a
                                                    href="/service/servisnyy-centr/" target="_blank"
                                                    >«Сервисном центре»</a>). Помните, что гарантия предоставляется только тем магазином, в котором была совершена покупка данного товара. Лучшая гарантия качества – это товары&nbsp;
                                                    <a href="/brands/" target="_blank"
                                                       >наших марок</a>: для них не требуется оформление гарантийного талона, достаточно предоставить чек.&nbsp;
                                                    <br/>
 <br/>
 <b>Внимание!</b>&nbsp;Некоторые товары невозможно проверить на работоспособность из-за отсутствия возможности их подключения в магазине.&nbsp; &nbsp;&nbsp;</span>
                                                </p>

                                            </div>

                                        </div>


                                    </div>
                                </div>


                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </MainLayout>
    )
}